// Shared static assets, imported as ES modules so Vite fingerprints them and
// rewrites the URLs relative to each consuming app's base. This is what makes
// them load in the packaged desktop app (loaded from `file://` with
// `base: "./"`) as well as on the web — a root-absolute `/favicon.svg` would
// resolve against the filesystem root under `file://` and 404.
//
// These files previously lived in `apps/web/public`; centralising them here
// removes the web/desktop duplication and the file:// path breakage at once.

import faviconUrl from "./favicon.svg";
import logoUrl from "./brand/logo.svg";
import logomarkUrl from "./brand/logomark.svg";
import appIconUrl from "./brand/app-icon.png";

import screenshotDashboard from "./screenshots/mobile-dashboard.png";
import screenshotGroupDetail from "./screenshots/mobile-group-detail.png";
import screenshotGroups from "./screenshots/mobile-groups.png";
import screenshotExpenseDetail from "./screenshots/mobile-expense-detail.png";
import screenshotProfile from "./screenshots/mobile-profile.png";

export {
  faviconUrl,
  logoUrl,
  logomarkUrl,
  appIconUrl,
  screenshotDashboard,
  screenshotGroupDetail,
  screenshotGroups,
  screenshotExpenseDetail,
  screenshotProfile,
};

/** Fetchable brand-kit sources, keyed by their download filename. */
export const brandKitAssets = {
  "logo.svg": logoUrl,
  "logomark.svg": logomarkUrl,
  "app-icon.png": appIconUrl,
} as const;
